import type { TreeTableDesignTokens, TreeTableTokenSections } from '@openng/optimus-ui-themes/types/treetable';

export const header: TreeTableTokenSections.Header = {
	background: '{primary.50}',
	borderColor: '{primary.100}',
	borderWidth: '1px',
	color: '{primary.400}',
};

export const headerCell: TreeTableTokenSections.HeaderCell = {
	background: '{primary.50}',
	hoverBackground: '{surface.50}',
	selectedBackground: '{surface.50}',
};

export const footer: TreeTableTokenSections.Footer = {
	borderWidth: '1px',
};

export const nodeToggleButton: TreeTableTokenSections.NodeToggleButton = {
	borderRadius: '{treetable.node.toggle.button.size} / 2',
};

export const paginatorTop: TreeTableTokenSections.PaginatorTop = {
	borderWidth: '1px',
};

export const paginatorBottom: TreeTableTokenSections.PaginatorBottom = {
	borderWidth: '1px',
};

export const colorScheme: TreeTableTokenSections.ColorScheme = {
	light: {
		bodyCell: {
			selectedBorderColor: '{surface.0}',
		},
	},
};

export default {
	header,
	headerCell,
	footer,
	nodeToggleButton,
	paginatorTop,
	paginatorBottom,
	colorScheme,
} satisfies TreeTableDesignTokens;
